import ZlbConfirm from '@/components/ZlbConfirm';
import {
  bankReceiptSync,
  getOrderTradeInfo,
  relationOrderTrade,
  reqBankReceiptCenterList,
  reqBankReceiptList,
  reqBankReceiptListByIncome,
  reqBankReceiptListByIntercourseFunds,
  saveFinancialAccount,
  unrelationOrderTrade,
  unrelationVoucher,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'bankReceipt',
  state: {
    bankReceiptlist: [],
  },
  effects: {
    // 查询往来款登记可关联银行回单
    *fetchBankReceiptListByIntercourseFunds({ payload }, { call, put }) {
      let params = payload;
      // 往来款登记可关联银行回单,暂时没有编辑操作，所以没有 formCode 字段，后续如果有的话，需要开放以下逻辑
      // const { formCode: intercourseId, ...rest } = payload;
      // params = {
      //   ...rest,
      //   intercourseId,
      // };

      const res = yield call(reqBankReceiptListByIntercourseFunds, params);
      responseErrorHandle(res);
      const { result = {} } = res;
      yield put({
        type: 'update',
        payload: {
          bankReceiptlist: result.data || [],
        },
      });
      return res;
    },
    // 查询收入未关联的银行回单列表
    *fetchBankReceiptListByIncome({ payload }, { call, put }) {
      const res = yield call(reqBankReceiptListByIncome, payload);
      responseErrorHandle(res);
      const { result = {} } = res;
      yield put({
        type: 'update',
        payload: {
          bankReceiptlist: result.data || [],
        },
      });
      return res;
    },
    // 列表
    *fetchBankReceiptList({ payload }, { call, put }) {
      const res = yield call(reqBankReceiptList, payload);
      responseErrorHandle(res);
      const { result = {} } = res;
      yield put({
        type: 'update',
        payload: {
          bankReceiptlist: result.data || [],
        },
      });
      return res;
    },

    // 银行回单中心列表
    *fetchBankReceiptCenterList({ payload }, { call, put }) {
      const res = yield call(reqBankReceiptCenterList, payload);
      responseErrorHandle(res);
      const { result = {} } = res;
      yield put({
        type: 'update',
        payload: {
          bankReceiptlist: result.data || [],
        },
      });
      return res;
    },
    *bankReceiptSync({ payload }, { call, put }) {
      try {
        return yield call(bankReceiptSync, payload);
      } catch (e) {}
    },

    // 添加财政零余额账户
    *saveFinancialAccount({ payload }, { call, put }) {
      const res = yield call(saveFinancialAccount, payload);
      return res;
    },
    // 查询支付单据交易明细
    *getOrderTradeInfo({ payload }, { call, put }) {
      const res = yield call(getOrderTradeInfo, payload);
      return res;
    },
    // 关联单据支付交易明细
    *relationOrderTrade({ payload }, { call, put }) {
      const res = yield call(relationOrderTrade, payload);
      return res;
    },
    // 取消关联单据支付交易明细
    *unrelationOrderTrade({ payload }, { call, put }) {
      const res = yield call(unrelationOrderTrade, payload);
      return res;
    },
    // 取消关联凭证
    *unrelationVoucher({ payload }, { call, put }) {
      const res = yield call(unrelationVoucher, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
